// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A_4xCTMdNYLG4GIGqfM4{color:var(--content-primary-tertiary);justify-content:center;align-items:center;margin-top:24px;padding:8px 8px 8px 12px;font-size:12px;font-weight:400;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyData": `A_4xCTMdNYLG4GIGqfM4`
};
export default ___CSS_LOADER_EXPORT___;
